import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './UsaAdultClasses.css';

const UsaAdultClasses = ({ onOpenModal }) => {
  return (
    <section className="usa-adult-classes" id="adult-classes">
      <div className="usa-adult-classes__container">
        <div className="usa-adult-classes__grid">
          {/* Left Column: Image */}
          <div className="usa-adult-classes__image-container">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Alquran-2.jpg`}
              alt="Adult learning Quran on laptop with headphones"
              className="usa-adult-classes__img"
            />
          </div>

          {/* Right Column: Copy */}
          <div className="usa-adult-classes__info">
            <h2 className="usa-adult-classes__title">
              It Is Never Too Late, Online Quran Classes For Adults In The USA
            </h2>

            <p className="usa-adult-classes__desc">
              Many adult Muslims grew up without proper Quranic education. Others learned as children but lost fluency over the years. Some accepted Islam later in life and want to connect with the Quran from scratch. Whatever your starting point, Al Quran Lesson offers adult-specific Quran classes that respect your intelligence, honor your schedule, and move at a pace you are comfortable with.
            </p>

            <p className="usa-adult-classes__desc">
              There is no judgment here. Our tutors are experienced in working with adult learners. People with careers, families, and limited time who are serious about learning properly. Whether your goal is to complete the Quran, memorize the Quran, understand the meaning of what you recite, or simply read correctly with Tajweed, we have a course and a tutor for you.
            </p>

            <button 
              onClick={onOpenModal}
              className="usa-adult-classes__cta-btn"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <span>Get Free Trial For Classes</span>
              <FiArrowRight className="usa-adult-classes__cta-arrow" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsaAdultClasses;
